const state = {
  userList: []
}
const mutations = {
  SETUSERLIST(state, userList) {
    state.userList = userList
  }
}
const actions = {
  setUserList({ commit }, userList) {
    commit('SETUSERLIST', userList)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}

